import ReactGA from "react-ga4";
import logger from '../logger/logHelper';

class EventTracker {
  static trackInit() {
    const id = process.env.REACT_APP_GA_TRACKING_ID;
    ReactGA.initialize(id, {
      gaOptions: {
        siteSpeedSampleRate: 100
      }
    });
  }

  static trackEvent(options) {
    const category = `mobile: ${options.category}`;
    const action = `mobile: ${options.action}`;
    const label = `mobile: ${options.label}`;
    ReactGA.event({
      category,
      action,
      label
    });
    const firstname = localStorage.getItem('firstname') || '';
    const lastname = localStorage.getItem('lastname') || '';
    const name = `${firstname} ${lastname}`;
    // let msg = '[ Google Analytics ]' + ' - Category: ' + options.category + ' - Action: ' + options.action + ' - Label: ' + options.label + ' - User: ' + name;
    const msg = `[ Google Analytics ] - Category: ${options.category} - Action: ${options.action} + Label: ${options.label} - User: ${name}`;
    logger.logInfo(msg);
  }

  static trackPageView() {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
      title: document.title
    });
    const msg = `[ Google Analytics ] - trackPageView: ${window.location.pathname + window.location.search} title: ${document.title}`;
    logger.logInfo(msg);
  }
}

export default EventTracker;
